import { render, staticRenderFns } from "./UploadedFilePreview.vue?vue&type=template&id=92837b46&scoped=true&"
import script from "./UploadedFilePreview.vue?vue&type=script&lang=js&"
export * from "./UploadedFilePreview.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFilePreview.vue?vue&type=style&index=0&id=92837b46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92837b46",
  null
  
)

export default component.exports